import { BaseAction } from './utils/baseAction';

export type ClearEditorMenuAction = BaseAction<'clearEditorMenu', void>;

export const clearEditorMenu = (): ClearEditorMenuAction => ({ type: 'clearEditorMenu', payload: undefined });
